module.exports = __webpack_public_path__ + "static/media/Ett Coachande Ledarskap.ad55d3e5.pdf";